import React from "react";
import { Badge } from "react-bootstrap";

interface IBadgeProps {
  contentType: number;
}

function TypeBadge({ contentType }: IBadgeProps) {
  if (contentType && contentType === 1) {
    return <Badge className="quiz-badge">Quiz</Badge>;
  }
  return <Badge className="lesson-badge">Lesson</Badge>;
}

export default TypeBadge;
